<template>
  <img
    :src="iconSrc"
    :alt="alt"
    class="product-icon"
    :class="`product-icon--${product}`"
  />
</template>

<script>
const PRODUCT_ICON_PATHS = Object.freeze({
  prospetti: "/menu/Icona Convertitore Prospetti Paghe.png",
  f24: "/menu/Icona Convertitore F24.png",
  bilancio: "/menu/Icona Convertitore Bilancio Analitico.png",
});

export default {
  name: "ProductIcon",
  props: {
    product: {
      type: String,
      required: true,
      validator: (value) =>
        Object.prototype.hasOwnProperty.call(PRODUCT_ICON_PATHS, value),
    },
    alt: {
      type: String,
      default: "",
    },
  },
  computed: {
    iconSrc() {
      return PRODUCT_ICON_PATHS[this.product];
    },
  },
};
</script>

<style scoped>
.product-icon {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>
